var map = {
	"./menu-analysis.png": "fbf5",
	"./menu-cloudscene.png": "7611",
	"./menu-equipment.png": "05d0",
	"./menu-home.png": "f0b5",
	"./menu-message.png": "ac98",
	"./menu-monitoring.png": "ba7f",
	"./menu-personal.png": "8ca1",
	"./menu-product.png": "c00c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23ad";